import { ReadonlyFieldProvider } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { FormattedMessage } from 'components/shared/Intl';
import { QuoteRepriceLink } from 'components/shared/QuoteRepriceLink';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FC } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { camelCaseToWords } from 'utils/string';

import { ProductSummaryBuilder } from './builder/ProductSummaryBuilder';
import { SummaryMailSender } from './mailSender/MailSender';
import type { SummaryProps } from './Summary.connect';

export const RawSummary: FC<SummaryProps> = ({
  quoteId,
  externalQuoteId,
  formEnrichedData,
  isOpened,
  summaryMetaData,
  onCloseSummary,
  tabId,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  const isInternal = useIsInternalUser();
  const id = 'summary';

  if (!isOpened || !formEnrichedData) {
    return null;
  }

  return (
    <>
      <Modal backdrop="static" dialogClassName={`${id}-component`} fade show={isOpened} size="xl">
        <ModalHeader>
          <ModalTitle as="h5">
            <FormattedMessage id={`productSummary.title.${id}` as any} defaultMessage={camelCaseToWords(id)} />
          </ModalTitle>
        </ModalHeader>

        <ModalBody>
          <div data-e2e={id} id={id}>
            {externalQuoteId && (
              <div
                className="alert alert-light fw-light d-flex flex-row"
                role="alert"
                data-e2e="quote-reload-container"
              >
                <FormattedMessage id="productSummary.openQuoteInSgMarkets" defaultMessage="Open quote in SG Markets:" />
                <QuoteRepriceLink
                  externalQuoteId={externalQuoteId}
                  quoteId={quoteId}
                  linkClassName="alert-link ms-2"
                  iconClassName="text-dark"
                  canShare={isInternal}
                />
              </div>
            )}
            {summaryMetaData && (
              <ReadonlyFieldProvider data={formEnrichedData}>
                <div id="summary-modal-component">
                  <ProductSummaryBuilder
                    tabId={tabId}
                    rootNodes={summaryMetaData}
                    quoteWorkspaceVersion={quoteWorkspaceVersion}
                    batchWorkspaceVersion={batchWorkspaceVersion}
                    mustForceAdvancedMode={mustForceAdvancedMode}
                  />
                </div>
              </ReadonlyFieldProvider>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-xl btn-default" onClick={onCloseSummary} data-e2e="close-product-summary">
            <FormattedMessage id="close" />
          </button>
          <SummaryMailSender externalQuoteId={externalQuoteId} />
        </ModalFooter>
      </Modal>
    </>
  );
};

RawSummary.displayName = 'SidePanelSummary';
